import {
  fromDeveloperDesdcriptor,
  finishDateDescriptor,
  priceInputDescriptors,
  priceTypeDescriptors,
  totalAreaInputDescriptors,
  manifestationTypeDescriptors,
  kitchenAreaInputDescriptors,
  livingAreaInputDescriptors,
  apartmentTypeDescriptors,
  penthouseTypeDescriptor,
  houseTypeDescriptor,
  newbuildingClassDescriptor,
  roomsDescriptor,
  regionDescriptor,
  geoDescriptor,
  newbuildingDescriptor,
  builderDescriptor,
  undergroundWalkTimeDescriptors,
  polygonDescriptor,
  hasDecorationDescriptors,
  constructionStatusDescriptors,
  hasMortgageDesdcriptor,
  saleTypeDescriptor,
  isSalesLeaderDescriptor,
  isSalesStartDescriptor,
  isBlackFridayDescriptor,
} from '../../constants/descriptors';
import { composeFilterDescriptors } from '../../containers/сonnectToDescriptors/descriptorToReducer';

export const jsonQuery = composeFilterDescriptors(
  ...priceInputDescriptors,
  ...priceTypeDescriptors,
  ...fromDeveloperDesdcriptor,
  ...finishDateDescriptor,
  ...manifestationTypeDescriptors,
  ...totalAreaInputDescriptors,
  ...kitchenAreaInputDescriptors,
  ...livingAreaInputDescriptors,
  ...apartmentTypeDescriptors,
  ...penthouseTypeDescriptor,
  ...houseTypeDescriptor,
  ...newbuildingClassDescriptor,
  ...roomsDescriptor,
  ...regionDescriptor,
  ...newbuildingDescriptor,
  ...builderDescriptor,
  ...geoDescriptor,
  ...undergroundWalkTimeDescriptors,
  ...polygonDescriptor,
  ...hasDecorationDescriptors,
  ...constructionStatusDescriptors,
  ...hasMortgageDesdcriptor,
  ...saleTypeDescriptor,
  ...isSalesLeaderDescriptor,
  ...isSalesStartDescriptor,
  ...isBlackFridayDescriptor,
);
